export default [
  {
    path: '/project-service',
    name: 'ProjectServiceManage',
    component: () => import('@/layouts/main.vue'),
    redirect: '/project-service/list',
    children: [
      {
        path: 'project-service/list',
        name: 'ProjectServiceManageProjectServiceList',
        component: () => import('@/views/project-service/service/views/list.vue'),
        meta: {
          title: '项目服务',
          noCache: false,
          auth: true,
        },
      },
      {
        path: 'approve-manage/list',
        name: 'ProjectServiceApproveManageList',
        component: () => import('@/views/project-service/approve-manage/list.vue'),
        meta: {
          title: '后端服务',
          noCache: false,
          auth: true,
        },
      },
      {
        path: 'approve-manage/detail/:serviceId',
        name: 'ProjectServiceApproveManageDetail',
        component: () => import('@/views/project-service/approve-manage/detail.vue'),
        meta: {
          title: '审批管理详情',
          noCache: false,
          auth: true,
        },
      },
      {
        path: 'project-service/add',
        name: 'ProjectServiceManageProjectServiceAdd',
        component: () => import('@/views/project-service/service/views/add.vue'),
        meta: {
          title: '新增',
          noCache: false,
          auth: true,
        },
      },
    ],
  },
];
